<template>
  <div :class="[ 'title', { 'title--active': active }]" in-viewport-root-margin='-20% 0' in-viewport-once="true">
    <slot />
  </div>
</template>

<style lang="scss">
.title{
  visibility: hidden;
  &--active{
    visibility: visible;
    .line__ct{
      transform: translate3d(0,10%,0);
    }
  }

  h1 > div,
  h2 > div{
    &:nth-child(1){
      .line__ct{
        transition-delay: 0;
      }
    }
    &:nth-child(2){
      .line__ct{
        transition-delay: .15s;
      }
    }
    &:nth-child(3){
      .line__ct{
        transition-delay: .3s;
      }
    }
    &:nth-child(4){
      .line__ct{
        transition-delay: .45s;
      }
    }
    &:nth-child(5){
      .line__ct{       
        transition-delay: .6s; 
      }
    }
  }
}



.line{
  overflow: hidden;
  width: 1000px;
  @media #{$bp-sm}{
    width: 100%;
  }
  &__ct{
    transition: transform 1.3s $easeInOutCubic;
    transform: translate3d(0,110%,0);
  }

  .text--center &{
    margin: 0 auto;
  }
}
</style>

<script>
import TweenLite from 'gsap/TweenLite'
import SplitText from '../vendor/SplitText'

import inViewport from 'vue-in-viewport-mixin'

export default {
  mixins: [ inViewport ],
  data() {
    return {
      active: false
    };
  },
  watch: {
    'inViewport.now': function(visible) {
      if( visible ) this.active = true
    }
  },
  computed:{
    
  },
  methods: {
    show(){

    } 
  },
  mounted() {

    if( this.$el.querySelector('h1') ){
      this.splitText = new SplitText(this.$el.querySelector('h1'), {type:"lines"})
    }else if( this.$el.querySelector('h2') ){
      this.splitText = new SplitText(this.$el.querySelector('h2'), {type:"lines"})  
    }else if( this.$el.querySelector('p') ){
      this.splitText = new SplitText(this.$el.querySelector('p'), {type:"lines"})  
    }
    
    let lines = this.splitText.lines;
    let org_html, new_html
    for( let i = 0; i < lines.length; i++ ){
      org_html = lines[i].innerHTML
      lines[i].innerHTML = "<div class='line'><div class='line__ct'>" + org_html + "</div></div>"
    }
  },
};
</script>
